<adapt-menu [items]="profileMenuItems"
            orientation="vertical"></adapt-menu>
